<template>
  <div class="m-t-20 row">

    <div class="col-md-10">
      <div class="d-flex justify-content-between mb-2">
        <div class="p2">

          <span class="text-blue me-1">{{ material.activitat_titol }}</span>
          <i v-if="material.activitat_rights === 'Open Access'" class="fas fa-lock-open text-warning" :title="material.activitat_rights"></i>
          <img v-else-if="material.activitat_rights === 'Restricted access to the UPC academic community'" src="../../assets/images/obertupc.png" :title="material.activitat_rights" alt="Restricted access to the UPC academic community">
          <img v-else-if="material.activitat_rights === 'Restricted access to the CSUC academic community'" src="../../assets/images/obertupc.png" :title="material.activitat_rights" alt="Restricted access to the CSUC academic community">
          <i v-else class="fas fa-lock text-warning" :title="material.activitat_rights"></i>
        </div>
      </div>

      <div>

        <div v-if="material.subtipus" class="text-upc-green fw-bolder mb-1">{{$t(material.subtipus)}}</div>
        <div v-else-if="material.activitat_subtipus_docencia" class="text-upc-green fw-bolder mb-1">{{$t(material.activitat_subtipus_docencia)}}</div>

        <div v-if="material.activitat_comunitat && material.activitat_comunitat[0] === 'pfc'">

          <div class="text-secondary mb-1" v-if="material.activitat_altresAutories">
            <i class="fa-solid fa-user text-secondary fa-xs me-1"></i>

            <span v-for="(altre, index) in material.activitat_altresAutories" v-bind:key="altre">
              {{altre}}<span v-if="index !== (material.activitat_altresAutories.length-1)">;</span>
            </span>
          </div>

          <div class="text-secondary mb-1" v-if="material.activitat_professors">
            {{$t('tutor')}}:
            <span v-for="(professor, index) in material.activitat_professors" v-bind:key="professor">
              {{professor.split('##')[0]}}<span v-if="index !== (material.activitat_professors.length-1)">;</span>
            </span>
          </div>

        </div>
        <div v-else>
          <div class="text-secondary mb-1" v-if="material.activitat_professors">

            <i class="fa-solid fa-user text-secondary fa-xs me-1"></i>
            <span v-for="(professor, index) in material.activitat_professors" v-bind:key="professor">
              {{professor.split('##')[0]}}<span v-if="index !== (material.activitat_professors.length-1)">;</span>
            </span>
          </div>
        </div>

        <div v-if="material.data" class="text-secondary mb-1">{{$t('Data de publicació')}}: {{ material.data }}</div>

        <div v-if="material.activitat_data_fin" class="text-secondary mb-1">{{$t('Data de finalitzacio')}}: {{ material.activitat_data_fin }}</div>

        <div v-if="material.activitat_isbn" class="text-secondary mb-1">
          ISBN:
          <span v-for="(isbn, index) in material.activitat_isbn" v-bind:key="isbn">
            {{isbn}}<span v-if="index !== (material.activitat_isbn.length-1)">;</span>
          </span>
        </div>

        <div class="mt-2" v-if="material.activitat_centres">
          <span v-for="centre in material.activitat_centres" v-bind:key="centre">
            {{ $t(centre) }}<br>
          </span>
        </div>

        <div class="mt-2 color-vermell fw-bolder" v-if="material.activitat_assignatures">
          <span v-for="assignatura in material.activitat_assignatures" v-bind:key="assignatura">
            {{ $t(assignatura) }}<br>
          </span>
        </div>

        <div class="mt-3">
          <button v-if="material.activitat_resum" @click.prevent='hideShow("resum"+index)' style="cursor:pointer; display: inline-block;" class="nav-link text-secondary me-4"><i class="fa-solid fa-search text-blue"></i> {{$t('Veure detall')}} </button>
          <a :href="'https://hdl.handle.net/' + material.id.replace('_','/')" target="_blank" rel="noreferrer noopener" class="text-secondary me-5" style="cursor:pointer; display: inline-block;" @click.stop><i class="fa-solid fa-file text-blue me-1"></i> {{$t('Accés al text complet')}}</a>
          <div v-bind:id="'resum'+index" class="alert alert-dark mt-3" style="display: none;">
            <div v-for="(resum, index) in material.activitat_resum" v-bind:key="resum">
              <div v-if="index !== (material.activitat_resum.length-1)" class="mb-4">{{resum}}</div>
              <div v-else>{{resum}}</div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="col-md-2 col-xs-12 d-none d-lg-block">
      <!--a v-bind:href="material.activitat_original" target="_blank" rel="noreferrer noopener"-->
      <img v-if="material.activitat_thumbnail" :src="material.activitat_thumbnail" @error="imageUrlAlt($event, material.activitat_rights)" alt="thumbnail" class="img-responsive float-left img-thumbnail rounded-0">
      <img v-else src="../../assets/images/no-thumbnail.png" alt="thumbnail" class="img-responsive float-left img-thumbnail rounded-0">
      <!--/a-->

    </div>
  </div>
</template>


<script>

import {imageUrlAlt} from "@/utils/utils";

export default {

  name: "ItemListMaterial",
  methods: {imageUrlAlt},
  props: {
    material: Object,
    index: Number
  },
  setup() {

    const hideShow = (index) => {
      const element = document.getElementById(index);
      if (element) {
        if (element.style.display === 'none') {
          element.style.display = 'block';
        } else {
          element.style.display = 'none';
        }
      }
    };

    return {
      hideShow

    }
  }
}
</script>

<style scoped>
button:hover {
  text-decoration: underline;
}
</style>
